var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"ellipsis"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.isEllipsis)?_c('q-tooltip',{attrs:{"max-width":"300px"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }